import React, { Component } from "react";
import { Col, Row } from "reactstrap";

import TransactionDetails from "../Components/TransactionDetails";

import transactions from "../../api/transactions";
import { handleError } from "@/util/errorHandler";

class ViewTransaction extends Component {
  state = {
    details: {},
    isLoading: true,
  };

  componentDidMount() {
    let id = this.props.match.params.id;
    this.loadTransaction(id);
  }

  loadTransaction = async id => {
    try {
      this.setState({
        details: await transactions.getTransaction(id),
      });
    } catch (error) {
      handleError(new Error(error.response.data.message));
    } finally {
      this.setState({ isLoading: false });
    }
  };

  goBack = props => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div>
        <Row>
          <Col>
            <TransactionDetails
              loading={this.state.isLoading}
              details={this.state.details}
              onBack={this.goBack}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default ViewTransaction;
